import { Button } from "components/Common/Button";
import { HelpTooltip } from "components/Common/HelpTooltip";
import { Loader } from "components/Common/Loader";
import { usePortal } from "contexts/PortalContext";
import settingsStyles from "../settingsDrawer.module.scss";
import { useChatHandle } from "contexts/ChatHandleContext";
import { fpSet } from "lib/fpLodash";
import {
  parseChatEntryToOutput,
  useChatLogReader,
} from "components/OverlayButtons/ChatBox/hooks/useChatLogger";
import { Modal } from "components/Common/Modal";
import { useState } from "react";
import { isEmpty, map } from "lodash";
import { ConfirmableDeleteButton } from "components/Common/ConfirmableDeleteButton/ConfirmableDeleteButton";

export const ChatRecorderSettings = ({ setTempUser }) => {
  const {
    chatHandle,
    populateChatHandle,
    isLoadingChatHandle,
    clearChatHandle,
    chatHandleError,
  } = useChatHandle();
  const { getChatLogOptions, clearChatLogs } = useChatLogReader();
  const portalProps = usePortal();
  const [chatLogOptions, setChatLogOptions] = useState([]);
  const [loadingLogOptions, setLoadingLogOptions] = useState(false);

  const setValue = (v) => {
    setTempUser((prev) => fpSet(`betaSettings.chatRecorderEnabled`, v, prev));
  };
  const getFolder = async () => {
    setValue(true);
    populateChatHandle();
    portalProps.setIsPortalComponentRendered(false);
  };

  const handleToggle = async () => {
    if (chatHandle) {
      clearChatHandle();
      setValue(false);
    } else {
      getFolder();
    }
  };

  return (
    <div className={"f-column"}>
      {/* <Modal
        contentClassName={settingsStyles["modal-content"]}
        portalProps={portalProps}
        title={"Are you sure?"}
        cancelText={"Cancel"}
        submitText={"Select Folder"}
        submitButtonProps={{
          colorful: true,
        }}
        onFooterSubmit={getFolder}
      >
        <div style={{ textAlign: "center", textDecoration: "underline" }}>
          By selecting a folder, you are granting us permission to read and
          write files in this folder.
        </div>
        <p>
          After you select a folder, we will store this permission locally in
          your browser. We do this so that you do not need to select it each
          time you refresh the page.
        </p>
        <p>
          You can revoke access at any time by clicking the "Disable" button in
          the Settings Drawer.
        </p>
        <i>
          Note: Chat logs may be missing if you haven't opened the app after 25+
          messages have been sent by other members of the group.
        </i>
      </Modal> */}
      <Modal
        contentClassName={settingsStyles["modal-content"]}
        portalProps={portalProps}
        title={"Click to Download"}
      >
        {loadingLogOptions ? (
          <Loader />
        ) : isEmpty(chatLogOptions) ? (
          <div style={{ textAlign: "center", fontWeight: "bold" }}>
            No chat logs found!
            <br />
            <br />
            Try navigating to a group with chat entries to generate a log. If
            logs still don't appear, try refreshing the page.
          </div>
        ) : (
          chatLogOptions.map(({ id, label, value }) => {
            return (
              <Button
                key={id}
                onClick={() => {
                  let res = map(value, parseChatEntryToOutput).join(
                    "\n\n----------------------------------------------\n----------------------------------------------\n\n"
                  );
                  res =
                    "----------------------------------------------\n----------------------------------------------\n\n" +
                    res +
                    "\n\n----------------------------------------------\n----------------------------------------------\n\n";

                  const a = document.createElement("a");
                  const blob = new Blob([res], { type: "text/plain" });

                  a.href = URL.createObjectURL(blob);
                  a.download = `Chat Log - ${label} (${id}) ${new Date().toLocaleDateString()} ${new Date().toLocaleTimeString()}.txt`;
                  a.click();
                  // console.log(res);
                }}
                className={settingsStyles["chat-record-download"]}
              >
                <div>{label}</div>
                <div style={{ color: "var(--light-gray)" }}>(ID: {id})</div>
              </Button>
            );
          })
        )}
      </Modal>
      <div className={"f-row"}>
        <span>Chat Recorder </span>
        <HelpTooltip>
          {chatHandle ? (
            'Click the "Disable" button to disable chat recording. The recordings will not be deleted by default. Click the "Clear Logs" button to delete the logs from your browser.'
          ) : (
            <span>
              We only store the last 25 chats in the chat box. If you want to
              store more than this, you can store the chat logs locally in your
              browser by enabling this feature.
              <br />
              <br />
              These recordings will not transfer across browsers. If a entry was
              visible while you were on the page, it will be recorded. Thus, if
              more than 25 chat entries are created without your presence, those
              entries will be missed.
              <br />
              <br />
              After clicking "Enable", a button will appear below labeled
              "Download Logs" which will open a window with a button for each
              group you have recordings of.
            </span>
          )}
        </HelpTooltip>
      </div>
      {chatHandleError && (
        <div className={settingsStyles["error"]}>
          {chatHandleError?.message || "Failed to setup handler"}
        </div>
      )}
      {
        <Button
          onClick={handleToggle}
          style={{ width: "100%" }}
          colorful={!!chatHandle}
          disabled={isLoadingChatHandle}
        >
          {isLoadingChatHandle ? (
            <Loader />
          ) : !chatHandle ? (
            "Enable"
          ) : (
            "Disable"
          )}
        </Button>
      }
      {chatHandle && (
        <>
          <Button
            onClick={async () => {
              portalProps.setIsPortalComponentRendered(true);
              setLoadingLogOptions(true);
              try {
                const options = await getChatLogOptions();
                setChatLogOptions(options);
              } catch (err) {
                alert(err.message);
              } finally {
                setLoadingLogOptions(false);
              }
            }}
          >
            Download Logs
          </Button>
          <ConfirmableDeleteButton
            description="This is a non-reversible action. Are you sure you want to permanently delete saved chat logs from your browser?"
            subDescription={
              'Note: this does not disable the feature. If you no longer want logs to be recorded. Click "Disable" after clearing the logs.'
            }
            onConfirm={async () => {
              clearChatLogs();
            }}
            modalProps={{
              continueText: "Clear",
            }}
          >
            Clear Logs
          </ConfirmableDeleteButton>
        </>
      )}
    </div>
  );
};
